
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  AccountManagerContactResource,
} from '../models';
import {
    AccountManagerContactResourceFromJSON,
    AccountManagerContactResourceToJSON,
} from '../models';

/**
 * 
 */
export class ClientCompanyAccountManagerApi extends runtime.BaseAPI {

    /**
          */
    async getCompanyAccountManagerContactRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<AccountManagerContactResource>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<AccountManagerContactResource>({
            path: `/client-settings/api/account-manager-contact`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=AccountManagerContactResourceFromJSON(response._data); }
        return response;
    }

    /**
          */
    async getCompanyAccountManagerContact(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<AccountManagerContactResource> {
        const response = await this.getCompanyAccountManagerContactRaw(initOverrides);
        return response._data;
    }

}
